export default __webpack_public_path__ + "static/media/3.92a0c914.jpg";